export default "__VITE_ASSET__C$CG7Uad__"